import About from '../pages/about';
import ExecTeam from '../pages/exec-team';
import Home from '../pages/home/home.js';
import TaxCollectorHome from '../pages/tax-collector/index';
import NewsPage from '../pages/news-publications/news-page';
import PublicationsPage from '../pages/news-publications/publications-page';
import HoursAndLocationsPage from '../pages/hours-and-locations/hours-and-locations-page';
import TreasurerHome from '../pages/treasurer';
import InvestmentPool from '../pages/treasurer/investment-pool';
import RFI from '../pages/treasurer/rfi.js';
import InvestmentDashboards from '../pages/treasurer/investment-dashboards.js'
import LegallyMandatedDuties from "../pages/treasurer/legally-mandated-duties.js"
import TreasurerAbout from '../pages/treasurer/treas-about.js';
import DivisionHomepageLayout from '../components/layouts/division-homepage-layout.js';
import AdministrationHome from '../pages/administration/index.js';
import DisbursementsHome from '../pages/disbursements/index.js';
import InformationTechnologyHome from '../pages/information-technology/index.js';
import AuditorHome from '../pages/auditor/index.js';
import PropertyTaxHome from '../pages/property-tax/index.js';
import RevenueRecoveryHome from '../pages/revenue-recovery/index.js';
import SAPHome from '../pages/sap-center-of-excellence/index.js';
import InformationTechnologyAbout from '../pages/information-technology/it-about.js';
import Callback from '../containers/callback.js';
import DocumentSearch from '../components/search/document-search/document-search.js';
import ImportantDates from '../pages/tax-collector/important-dates';
import JotFormContainer from '../components/jotform-container.js';
import SupplementalTaxBillInfo from '../pages/tax-collector/supplemental-tax-bill-info';
import DefaultLayout from '../components/layouts/default-layout.js';
import AwardsAndAccolades from '../pages/awards-and-accolades/awards-and-accolades.js';
import DisbursementsAbout from '../pages/disbursements/disb-about.js';
import AuditorAbout from '../pages/auditor/auditor-about.js';
import TaxCollectorAbout from '../pages/tax-collector/tc-about.js';
import ControllerHome from '../pages/controller/index.js';
import RevenueRecoveryAbout from '../pages/revenue-recovery/rvr-about.js';
import SAPAbout from '../pages/sap-center-of-excellence/sap-about.js';
import ControllerAbout from '../pages/controller/controller-about.js';
import PropertyTaxAbout from '../pages/property-tax/pt-about.js';
import FAQ from '../pages/faq/faq.js';
import GovHubServiceLinks from '../pages/govhub-services/govhub-service-links.js';
import GovHubServices from '../pages/govhub-services/govhub-services.js';
import { govHubSubPath } from '../utils/utils.js';
import SuccessorAgencyDissolutionInformation from '../pages/property-tax/successor-agency-dissolution-information.js';
import InternalAudits from '../pages/auditor/internal-audits-info.js';
import PrivacySettings from '../pages/privacy-settings.js';
import PrivacyPolicy from '../pages/privacy-policy.js';
import DirectCharges from '../pages/property-tax/direct-charges.js';
import GeneralAccounting from '../pages/controller/general-accounting.js';
import ManagementServices from '../pages/controller/management-services.js';
import ControllerAwards from '../pages/controller/controller-awards.js';
import DisbursementsAwardsPage from '../pages/disbursements/disbursements-awards.js';
import SAPAwardsPage from '../pages/sap-center-of-excellence/sap-awards.js';
import TreasurerAwardsPage from '../pages/treasurer/treasurer-awards.js';
import GlobalSearchResult from '../components/search/global-search/global-search-result.js';
import PropertyTaxAwardsPage from '../pages/property-tax/property-tax-awards.js';
import ApportionmentReport from '../pages/property-tax/apportionment-report.js';
import RedevelopmentPropertyTaxTrustFund from '../pages/property-tax/redevelopment-property-tax-trust-fund.js';
import SubdivisionMaps from '../pages/property-tax/subdivision-maps.js';
import PublicAcquisitions from '../pages/property-tax/public-acquisitions.js';
import ContactUsPage from '../pages/contact-us/index.js';
import TaxCollectorAwardsPage from '../pages/tax-collector/tax-collector-awards.js';
import DisbursementsVendorFormsPage from '../pages/disbursements/disbursements-vendor-forms';
import WDMPTDGPage from '../pages/property-tax/wdmptdg-page.js';
import ITAwardsPage from '../pages/information-technology/it-awards.js';
import ATCSupportDevelopmentInnovation from '../pages/information-technology/atc-support-development-innovation';


const divHomePage = {
    treasurer: { tag: 'treasurer', title: 'Treasurer Division', divisionAbbreviation: 'TRE' },
    taxCollector: { tag: 'taxCollector', title: 'Tax Collector Division', divisionAbbreviation: 'TXC' },
    itd: { tag: 'itd', title: 'Information Technology Division', divisionAbbreviation: 'ITD' },
    propertyTax: { tag: 'propertyTax', title: 'Property Tax Division', divisionAbbreviation: 'PT' },
    internalAudits: { tag: 'internalAudits', title: 'Internal Audits Division', divisionAbbreviation: 'AUD' },
    revenueRecovery: { tag: 'revenueRecovery', title: 'Revenue Recovery Division', divisionAbbreviation: 'RVR' },
    sap: { tag: 'sap', title: 'SAP Center of Excellence Division', divisionAbbreviation: 'SAP' },
    controller: { tag: 'controller', title: 'Controller Division', divisionAbbreviation: 'CTL' },
    administration: { tag: 'administration', title: 'Administration Division', divisionAbbreviation: 'ADM' },
    disbursements: { tag: 'disbursements', title: 'Disbursements Division', divisionAbbreviation: 'DSB' }
}


const routes = [

    {
        path: '/Home', component: <Home />, meta: { title: 'Home', description: 'Welcome to the Home page.' }
    },
    {
        path: '/', component: <Home />, meta: { title: 'Home', description: 'Welcome to the Home page.' }
    },
    {
        path: '/callback', component: <Callback />, meta: { title: 'Callback', description: 'Callback page.' }
    },
    {
        path: '/tax-collector', component: <DivisionHomepageLayout division={divHomePage.taxCollector}><TaxCollectorHome division={divHomePage.taxCollector} /></DivisionHomepageLayout>, meta: { title: 'Tax Collector', description: 'Tax Collector Home page.' }
    },
    {
        path: '/tax-collector/about', component: <DivisionHomepageLayout division={divHomePage.taxCollector}><TaxCollectorAbout division={divHomePage.taxCollector} /></DivisionHomepageLayout>, meta: { title: 'About Tax Collector', description: 'About the Tax Collector.' }
    },
    {
        path: '/tax-collector/supplemental-tax-bill-info', component: <DivisionHomepageLayout division={divHomePage.taxCollector}><SupplementalTaxBillInfo /></DivisionHomepageLayout>, meta: { title: 'Supplemental Tax Bill Info', description: 'Information about Supplemental Tax Bills.' }
    },
    {
        path: '/tax-collector/important-dates', component: <DivisionHomepageLayout division={divHomePage.taxCollector}><ImportantDates /></DivisionHomepageLayout>, meta: { title: 'Important Dates', description: 'Important dates for Tax Collector.' }
    },
    {
        path: '/tax-collector/awards', component: <DivisionHomepageLayout division={divHomePage.treasurer}><TaxCollectorAwardsPage /></DivisionHomepageLayout>, meta: { title: 'Tax Collector Awards', description: 'Awards and achievements for the Tax Collector Divisions' }
    },
    {
        path: '/exec-team', component: <DefaultLayout title="ATC Executives" ><ExecTeam /></DefaultLayout>, meta: { title: 'Executive Team', description: 'Meet the ATC Executive Team.' }
    },
    {
        path: '/about', component: <DefaultLayout title="About ATC" ><About /></DefaultLayout>, meta: { title: 'About ATC', description: 'Learn more about ATC.' }
    },
    {
        path: '/treasurer', component: <DivisionHomepageLayout division={divHomePage.treasurer}><TreasurerHome division={divHomePage.treasurer} /></DivisionHomepageLayout>, meta: { title: 'Treasurer', description: 'Treasurer Home page.' }
    },
    {
        path: '/treasurer/investment-pool', component: <DivisionHomepageLayout division={divHomePage.treasurer}><InvestmentPool /></DivisionHomepageLayout>, meta: { title: 'Investment Pool', description: 'Information about the Investment Pool.' }
    },
    {
        path: '/treasurer/rfi', component: <DivisionHomepageLayout division={divHomePage.treasurer}><RFI /></DivisionHomepageLayout>, meta: { title: 'RFI', description: 'Request for Information.' }
    },
    {
        path: '/treasurer/rfi/:formIdentifier', component: <JotFormContainer pageTitle="Treasurer" />, meta: { title: 'RFI Form', description: 'Request for Information Form.' }
    },
    {
        path: '/treasurer/legally-mandated-duties', component: <DivisionHomepageLayout division={divHomePage.treasurer}><LegallyMandatedDuties /></DivisionHomepageLayout>, meta: { title: 'Legally Mandated Duties', description: 'Information about legally mandated duties.' }
    },
    {
        path: '/treasurer/awards', component: <DivisionHomepageLayout division={divHomePage.treasurer}><TreasurerAwardsPage /></DivisionHomepageLayout>, meta: { title: 'Treasurer Awards', description: 'Awards and achievements for the Treasurer Divisions' }
    },
    {
        path: '/treasurer/investment-dashboards', component: <DivisionHomepageLayout division={divHomePage.treasurer}><InvestmentDashboards /></DivisionHomepageLayout>, meta: { title: 'Investment Dashboards', description: 'Investment dashboards.' }
    },
    {
        path: '/treasurer/about', component: <DivisionHomepageLayout division={divHomePage.treasurer}><TreasurerAbout division={divHomePage.treasurer} /></DivisionHomepageLayout>, meta: { title: 'About Treasurer', description: 'Learn more about the Treasurer.' }
    },
    {
        path: '/news', component: <DefaultLayout title="News and Newsletters"><NewsPage></NewsPage></DefaultLayout>, meta: { title: 'News', description: 'Latest news and newsletters.' }
    },
    {
        path: '/newsletters', component: <DefaultLayout title="News and Newsletters"><PublicationsPage></PublicationsPage></DefaultLayout>, meta: { title: 'Newsletters', description: 'Latest newsletters.' }
    },
    {
        path: '/hours-and-locations', component: <DefaultLayout title="Hours, Locations, and Contact Numbers"><HoursAndLocationsPage /></DefaultLayout>, meta: { title: 'Hours, Locations, and Contact Numbers', description: 'Find our hours, locations, and contact numbers.' }
    },
    {
        path: '/awards-and-accolades', component: <DefaultLayout title="Awards and Accolades"><AwardsAndAccolades /></DefaultLayout>, meta: { title: 'Awards and Accolades', description: 'Our awards and accolades.' }
    },
    {
        path: '/administration', component: <DivisionHomepageLayout division={divHomePage.administration}><AdministrationHome division={divHomePage.administration} /></DivisionHomepageLayout>, meta: { title: 'Administration', description: 'Administration Home page.' }
    },
    {
        path: '/disbursements', component: <DivisionHomepageLayout division={divHomePage.disbursements}><DisbursementsHome division={divHomePage.disbursements} /></DivisionHomepageLayout>, meta: { title: 'Disbursements', description: 'Disbursements Home page.' }
    },
    {
        path: '/disbursements/about', component: <DivisionHomepageLayout division={divHomePage.disbursements}><DisbursementsAbout division={divHomePage.disbursements} /></DivisionHomepageLayout>, meta: { title: 'About Disbursements', description: 'Learn more about Disbursements.' }
    },
    {
        path: '/disbursements/awards', component: <DivisionHomepageLayout division={divHomePage.disbursements}><DisbursementsAwardsPage /></DivisionHomepageLayout>, meta: { title: 'Disbursement Awards', description: 'Awards and achievements for the Disbursements Division.' }
    },
    {
        path: '/disbursements/vendor-forms', component: <DivisionHomepageLayout division={divHomePage.disbursements}><DisbursementsVendorFormsPage /></DivisionHomepageLayout>, meta: { title: 'Disbursement Vendor Forms', description: 'Access essential vendor-related forms, including Direct Deposit Agreement, New Vendor Code Request, and Change of Information Form.' }
    },
    {
        path: '/information-technology', component: <DivisionHomepageLayout division={divHomePage.itd}><InformationTechnologyHome division={divHomePage.itd} /></DivisionHomepageLayout>, meta: { title: 'Information Technology', description: 'Information Technology Home page.' }
    },
    {
        path: '/information-technology/about', component: <DivisionHomepageLayout division={divHomePage.itd}><InformationTechnologyAbout division={divHomePage.itd} /></DivisionHomepageLayout>, meta: { title: 'About Information Technology', description: 'Learn more about Information Technology.' }
    },
    {
        path: '/information-technology/awards', component: <DivisionHomepageLayout division={divHomePage.itd}><ITAwardsPage /></DivisionHomepageLayout>, meta: { title: 'Information Technology Awards', description: 'Awards and achievements for the Information Technology Division' }
    },
    {
        path: '/information-technology/atc-support-development-innovation', component: <DivisionHomepageLayout division={divHomePage.itd}><ATCSupportDevelopmentInnovation /></DivisionHomepageLayout>, meta: { title: 'ATC Support Development Innovation', description: 'ATC Support Development Innovation for the Information Technology Division' }
    },
    {
        path: '/internal-audits', component: <DivisionHomepageLayout division={divHomePage.internalAudits}><AuditorHome division={divHomePage.internalAudits} /></DivisionHomepageLayout>, meta: { title: 'Auditor', description: 'Auditor Home page.' }
    },
    {
        path: '/internal-audits/about', component: <DivisionHomepageLayout division={divHomePage.internalAudits}><AuditorAbout division={divHomePage.internalAudits} /></DivisionHomepageLayout>, meta: { title: 'About Auditor', description: 'Learn more about the Auditor.' }
    },
    {
        path: '/internal-audits/internal-audits-info', component: <DivisionHomepageLayout division={divHomePage.internalAudits}><InternalAudits division={divHomePage.internalAudits} /></DivisionHomepageLayout>, meta: { title: 'Internal Audits', description: 'Learn more about the Internal Audits Division.' }
    },
    {
        path: '/internal-audits/independence-of-the-auditor-function', component: <DivisionHomepageLayout division={divHomePage.internalAudits}><InternalAudits division={divHomePage.internalAudits} /></DivisionHomepageLayout>, meta: { title: 'Independence of the Auditor Function', description: 'Independence of the Auditor Function.' }
    },
    {
        path: '/property-tax', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><PropertyTaxHome division={divHomePage.propertyTax} /></DivisionHomepageLayout>, meta: { title: 'Property Tax', description: 'Property Tax Home page.' }
    },
    {
        path: '/property-tax/about', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><PropertyTaxAbout division={divHomePage.propertyTax} /></DivisionHomepageLayout>, meta: { title: 'About Property Tax', description: 'Learn more about Property Tax.' }
    },
    {
        path: '/tax-services/direct-charges', component: <DirectCharges division={divHomePage.propertyTax} />, meta: { title: 'Direct Charges', description: 'Learn more about Direct Charges.' }
    },
    {
        path: '/property-tax/successor-agency-dissolution-information', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><SuccessorAgencyDissolutionInformation /></DivisionHomepageLayout>, meta: { title: 'Successor Agency Dissolution Information', description: 'Successor Agency Dissolution Information.' }
    },
    {
        path: '/property-tax/property-tax-awards', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><PropertyTaxAwardsPage /></DivisionHomepageLayout>, meta: { title: 'Property Tax Awards', description: 'Awards and achievements for the Property Tax Divisions' }
    },
    {
        path: '/property-tax/apportionment-report', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><ApportionmentReport /></DivisionHomepageLayout>, meta: { title: 'Apportionment Report', description: 'Apportionment Report.' }
    },
    {
        path: '/property-tax/redevelopment-property-tax-trust-fund', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><RedevelopmentPropertyTaxTrustFund /></DivisionHomepageLayout>, meta: { title: 'Redevelopment Property Tax Trust Fund', description: 'Redevelopment Property Tax Trust Fund' }
    },
    {
        path: '/property-tax/subdivision-maps', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><SubdivisionMaps /></DivisionHomepageLayout>, meta: { title: 'Subdivision Maps', description: 'Subdivision Maps' }
    },
    {
        path: '/property-tax/public-acquisitions', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><PublicAcquisitions /></DivisionHomepageLayout>, meta: { title: 'Public Acquisitions', description: 'Public Acquisitions' }
    },
    // {
    //     path: '/property-tax/gis-dashboard', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><GISDashboard /></DivisionHomepageLayout>, meta: { title: 'GIS Dashboard', description: 'GIS Dashboard' }
    // },
    {
        path: '/property-tax/where-do-my-property-tax-dollars-go', component: <DivisionHomepageLayout division={divHomePage.propertyTax}><WDMPTDGPage /></DivisionHomepageLayout>, meta: { title: 'Where Do  My Property Tax Dollars Go', description: 'Where Do  My Property Tax Dollars Go' }
    },
    {
        path: '/revenue-recovery', component: <DivisionHomepageLayout division={divHomePage.revenueRecovery}><RevenueRecoveryHome division={divHomePage.revenueRecovery} /></DivisionHomepageLayout>, meta: { title: 'Revenue Recovery', description: 'Revenue Recovery Home page.' }
    },
    {
        path: '/revenue-recovery/about', component: <DivisionHomepageLayout division={divHomePage.revenueRecovery}><RevenueRecoveryAbout division={divHomePage.revenueRecovery} /></DivisionHomepageLayout>, meta: { title: 'About Revenue Recovery', description: 'Learn more about Revenue Recovery.' }
    },
    {
        path: '/sap', component: <DivisionHomepageLayout division={divHomePage.sap}><SAPHome division={divHomePage.sap} /></DivisionHomepageLayout>, meta: { title: 'SAP Center of Excellence', description: 'SAP Center of Excellence Home page.' }
    },
    {
        path: '/sap/about', component: <DivisionHomepageLayout division={divHomePage.sap}><SAPAbout division={divHomePage.sap} /></DivisionHomepageLayout>, meta: { title: 'About SAP Center of Excellence', description: 'Learn more about SAP Center of Excellence.' }
    },
    {
        path: '/sap/awards', component: <DivisionHomepageLayout division={divHomePage.sap}><SAPAwardsPage /></DivisionHomepageLayout>, meta: { title: 'SAP Awards', description: 'Awards and achievements for the SAP Division.' }
    },
    {
        path: '/controller', component: <DivisionHomepageLayout division={divHomePage.controller}><ControllerHome division={divHomePage.controller} /></DivisionHomepageLayout>, meta: { title: 'Controller', description: 'Controller Home page.' }
    },
    {
        path: '/controller/about', component: <DivisionHomepageLayout division={divHomePage.controller}><ControllerAbout division={divHomePage.controller} /></DivisionHomepageLayout>, meta: { title: 'About Controller', description: 'Learn more about the Controller.' }
    },
    {
        path: '/controller/general-accounting', component: <DivisionHomepageLayout division={divHomePage.controller}><GeneralAccounting /></DivisionHomepageLayout>, meta: { title: 'General Accounting', description: 'Controller General Accounting.' }
    },
    {
        path: '/controller/management-services', component: <DivisionHomepageLayout division={divHomePage.controller}><ManagementServices /></DivisionHomepageLayout>, meta: { title: 'Management Services', description: 'Controller Management Services.' }
    },
    {
        path: '/controller/awards', component: <DivisionHomepageLayout division={divHomePage.controller}><ControllerAwards /></DivisionHomepageLayout>, meta: { title: 'Controller Awards', description: 'Controller Controller Awards.' }
    },
    {
        path: '/search/documents', component: <DocumentSearch />, meta: { title: 'Document Search', description: 'Search for documents.' }
    },
    {
        path: '/online-services/:formIdentifier', component: <JotFormContainer pageTitle="Online Services" />, meta: { title: 'Online Services', description: 'Access online services.' }
    },
    {
        path: '/forms/:formIdentifier', component: <JotFormContainer pageTitle="Online Services" />, meta: { title: 'Forms', description: 'Access forms.' }
    },
    {
        path: '/faq', component: <DefaultLayout title="FAQ"><FAQ /></DefaultLayout>, meta: { title: 'FAQ', description: 'Frequently Asked Questions.' }
    },
    {
        path: '/global-search-result', component: <DefaultLayout title="Search Result" ><GlobalSearchResult /></DefaultLayout>, meta: { title: 'Global Search Result', description: 'Search results for global services.' }
    },
    {
        path: '/' + govHubSubPath, component: <GovHubServiceLinks></GovHubServiceLinks>, meta: { title: 'GovHub Services', description: 'Links to GovHub services.' }
    },
    {
        path: '/' + govHubSubPath + '/:serviceUrl/*', component: <GovHubServices></GovHubServices>, meta: { title: 'GovHub Service', description: 'GovHub service details.' }
    },
    {
        path: '/privacy-settings', component: <DefaultLayout title="Privacy Settings"><PrivacySettings /></DefaultLayout>, meta: { title: 'Privacy Settings', description: 'Manage your privacy settings.' }
    },
    {
        path: '/privacy-policy', component: <DefaultLayout title="Privacy Policy"><PrivacyPolicy /></DefaultLayout>, meta: { title: 'Privacy Policy', description: 'Privacy policy of the San Bernardino ATC Website.' }
    },
    {
        path: "/contact-us", component: (<DefaultLayout title="Contact Us"><ContactUsPage /></DefaultLayout>), meta: { title: "Contact Us", description: "Get in touch with us online." }
    }
];

export default routes;
